/**
 * useInterval — un minuteur répété, relancé quand son délai change, coupé au démontage ; `null` le
 * met en pause. Le même que `common/utils/useInterval` (le moteur n'importe pas `common/`), pour les
 * fichiers du live déplacés dans le moteur.
 */
import { useEffect, useRef } from "react"

export function useInterval(callback: () => void, delay: number | null): void {
    const savedCallback = useRef(callback)

    useEffect(() => {
        savedCallback.current = callback
    }, [callback])

    useEffect(() => {
        if (delay === null) return undefined
        const id = setInterval(() => savedCallback.current(), delay)
        return () => clearInterval(id)
    }, [delay])
}
